<ng-container *transloco="let t;">
<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">{{t('Bulk upload modal title (bulk upload) - Bulk Upload')}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="bulkUploadModalClose('close')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body p-0" tabindex="0" ngbAutofocus>
    <div>
        <!-- Step Uploading -->
        <div class="row m-0 ps-50 pe-50 bulk-upload-step" id="bulk-upload-step-upload" [class.active]="(stepOrderService.currentStep$ | async) === BulkUploadStepsEnum.UPLOAD_CSV">
            <app-upload-files-init-step [acceptableFiles] ="acceptableCSVFiles" [form]="uploadCSVForm"  [submitted] ="csvFileSubmitted" [isLoading]="(stepOrderService.stepLoading$ | async)"></app-upload-files-init-step>
            
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="bulkUploadModalClose('close')" rippleEffect>
                    {{ t('Cancel button (bulk upload) - Cancel') }}
                </button>
                <button type="button" class="btn btn-outline-secondary" [disabled]="isSkipStepLoading" (click)="skip()" rippleEffect>
                    <span *ngIf="isSkipStepLoading" class="spinner-border spinner-border-sm me-1"></span> {{t('Skip button (bulk upload) - Skip this step')}}
                </button>
                <button type="button" class="btn btn-success" (click)="uploadCSV()" rippleEffect  [disabled]= "(stepOrderService.stepLoading$ | async) || csvFileSubmitted && uploadCSVForm?.invalid">
                    {{ t('Next button (bulk upload) - Next') }}
                </button>
            </div>
        </div>
        <!-- / Step Uploading -->

        <!-- Step Mapping -->
        <div class="row m-0 p-0 bulk-upload-step" id="bulk-upload-step-mapping" [class.active]="(stepOrderService.currentStep$ | async) === BulkUploadStepsEnum.FIELD_MAPPING">
            <app-match-columns-step  [first_line_titles]=" stepOrderService.first_line_titles" [defaultFields]="stepOrderService.mappings$ | async" (first_line_titlesChange)="firstLineTitlesChange($event)"  [rowItems]="stepOrderService.rowItems$ | async" [cardColumns]="stepOrderService.cardColumns$ | async"  [loading]="(stepOrderService.stepLoading$ | async) === true" (mappingChange)="onMappingChange($event)"></app-match-columns-step>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="prev()" rippleEffect>
                    {{ t('Back button (bulk upload) - Back') }}
                </button>
                <button type="button" class="btn btn-success" [disabled]="stepOrderService.stepLoading$ | async" (click)="next()" rippleEffect>
                     <span *ngIf="stepOrderService.stepLoading$ | async" class="spinner-border spinner-border-sm me-1"></span> {{ t('Next button (bulk upload) - Next') }}
                </button>
            </div>
        </div>
        <!-- / Step Mapping -->

        <!-- Handle duplicates -->
        <div class="row m-0 p-0 bulk-upload-step" id="bulk-upload-step-handle-duplicates" [class.active]="(stepOrderService.currentStep$ | async) === BulkUploadStepsEnum.HANDLE_DUPLICATES">
            <app-handle-duplicates-step [mergeOrganisations]="stepOrderService.mergeOrganisations" (mergeOrganisationsChange)="onMergeOrganisationsChanged($event)" ></app-handle-duplicates-step>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="prev()" rippleEffect>
                    {{ t('Back button (bulk upload) - Back') }}
                </button>
                <button type="button" class="btn btn-success" rippleEffect (click)="next()">
                    {{ t('Next button (bulk upload) - Next') }}
                </button>
            </div>
        </div>

        <!-- Step Preview & Finalize -->
        <div class="row m-0 p-0 bulk-upload-step" id="bulk-upload-step-preview-finalize" [class.active]="(stepOrderService.currentStep$ | async) === BulkUploadStepsEnum.PREVIEW">
            <app-upload-preview-step 
                    [previewData]="stepOrderService.previewData$ | async"
                    [invalidData]="stepOrderService.invalidData$ | async"
                    [statistics]="stepOrderService.importStats$ | async"
                    [columns]="stepOrderService.previewColumns$ | async"
                    [isImporting]="stepOrderService.importInProgress$ | async"
                    [isImported]="stepOrderService.importCompleted$ | async"
                    (importXLSClicked)="importXLS()" 
                    (previewNextClicked)="onPreviewNext()"
                    (exportFailedDataClicked)="onExportFailedDataClicked()"></app-upload-preview-step>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="prev()" rippleEffect>
                    {{ t('Back button (bulk upload) - Back') }}
                </button>
            </div>
        </div>
        <!-- / Step Preview & Finalize -->

        <!-- Step Uploading Files -->
        <div class="row m-0 ps-50 pe-50 bulk-upload-step d-flex" id="bulk-upload-step-upload" [class.active]="(stepOrderService.currentStep$ | async) === BulkUploadStepsEnum.UPLOAD_PDF" [formGroup]="uploadForm">
            <app-bulk-upload-pdf-files-step [maxFileSize]="maxFileSize" 
            [pdfMatching]=" importCSVResponse$ | async"
            [contractCards]="contractCards$ | async"
            (contractCardsSearchChanged)="onContractCardsSearchChanged($event)"
            class="d-flex"></app-bulk-upload-pdf-files-step>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xl-12 col-lg-6">
                        <form>
                            <div class="custom-control mb-1 custom-checkbox">
                                <input name="shouldAddActivityToContractCard" type="checkbox" class="custom-control-input" id="shouldAddActivityToContractCard" [(ngModel)]="shouldAddActivityToContractCard" (ngModelChange)="onShouldAddActivityToContractCardChange($event)"   />
                                <label class="custom-control-label" for="shouldAddActivityToContractCard">{{ t("Add a activity to each created Contract Card checkbox label text - (CC Import AI modal) - Add a activity to each created Contract Card") }}</label>
                                <app-question-mark class="ms-1" [tooltipText]="t('Add a activity to each created Contract Card tooltip text - (CC Import AI modal) - You can add an activity to each created contract card and assign it to a manager')"></app-question-mark>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <app-ai-generate-activity *ngIf="shouldAddActivityToContractCard === true" [submitted] = uploadModalSubmitted (formDataChanged)="onActivityFormDataChanged($event)" (isValid)="onActivityFormDataValidityChanged($event)" ></app-ai-generate-activity>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="prev()" rippleEffect>
                    {{ t('Back button (bulk upload) - Back') }}
                </button>
                <button type="button" class="btn btn-success" (click)="onMoveToNextStepFromUploadPDF()" rippleEffect>
                    {{ t('Next button (bulk upload) - Next') }}
                </button>
            </div>
        </div>
        <!-- / Step Uploading Files -->

        <!-- Step Matching Files -->
        <div class="row m-0 p-0 bulk-upload-step" id="bulk-upload-step-file-match" [class.active]="(stepOrderService.currentStep$ | async) === BulkUploadStepsEnum.MATCH_FILES">
            <app-match-contract-cards-step  [categories]="stepOrderService?.pdfImportSummary?.categories ?? []"  [contractCards]="stepOrderService?.pdfImportSummary?.contract_controls ?? []" [organizations] ="stepOrderService?.pdfImportSummary?.organizations ?? []"></app-match-contract-cards-step>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="prev()" rippleEffect>
                    {{ t('Back button (bulk upload) - Back') }}
                </button>
                <button type="button" class="btn btn-success" rippleEffect (click)="onImportPDFClick()">
                    {{ t('Close button (bulk upload) - Close') }}
                </button>
            </div>
        </div>
    </div>
</div>
</ng-container>
